


















import { defineComponent, PropType } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PostFileData } from "@/types";
import BaseInputFile from "@/components/BaseInputFile";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import EditPostOverview from "../EditPostOverview";

export default defineComponent({
  name: "CreatePostView",
  components: { EditPostOverview, BaseInputFile, BasePage, PageTitle },
  props: {
    loading: { type: Boolean, required: true },
    postData: { type: Object as PropType<ContentSet | null> },
    fileList: { type: Array as PropType<PostFileData[]>, required: true },
  },
});
